import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { faqs } from '../data/mock';

const FAQ = () => {
  const [openId, setOpenId] = useState(null);

  const toggleFAQ = (id) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section id="faq" className="faq-section">
      <div className="container">
        <div className="section-header">
          <h2 className="heading-1">Frequently Asked Questions</h2>
          <p className="body-large section-subtitle">
            Everything you need to know about sessions and services
          </p>
        </div>

        <div className="faq-container">
          {faqs.map((faq) => (
            <div 
              key={faq.id} 
              className={`faq-item ${openId === faq.id ? 'open' : ''}`}
            >
              <button 
                className="faq-question"
                onClick={() => toggleFAQ(faq.id)}
              >
                <span>{faq.question}</span>
                <ChevronDown 
                  size={20} 
                  className={`chevron ${openId === faq.id ? 'rotated' : ''}`}
                />
              </button>
              
              {openId === faq.id && (
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
